import { useEffect, useState } from "react";
import { CustomDataGrid } from "../../../common/components/Table/CustomDataGrid";
import { udGridColumns } from "../utilis/udGridColumns";
import { load_ud_data_from_backend } from "../utilis/udServices";

const TabContent = ({ tabName, hiddenColumns }) => {
    const [data, setData] = useState([]);
    const columnsData = Object.values(udGridColumns);
    // console.log(columnsData);
    const loadData = () => {
        load_ud_data_from_backend(data, setData, tabName);
    };
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            loadData();
        }, 100);

        return () => {
            clearTimeout(timeoutId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabName]);
    // console.log(data);
    return (
        <>
            {
                data && <CustomDataGrid
                    columns={columnsData}
                    rows={data || []}
                    initialState={{
                        columns: {
                            columnVisibilityModel: hiddenColumns,
                        },
                        pinnedColumns: {
                            right: [
                                "document_received_date",
                                "UD remark",

                            ]
                        }
                    }}
                    sx={{
                        height: "700px"
                    }}
                />
            }


        </>
    );
};
export default TabContent;